import { useMutation } from '@tanstack/react-query';
import { DocsRequests } from 'src/requests/docs';

export const useDocExportMutation = () => {
  const { mutateAsync: exportDoc, isLoading: isExportingDoc } = useMutation(
    (docId?: string) => DocsRequests.exportDoc(docId),
  );

  return {
    exportDoc,
    isExportingDoc,
  };
};
